// src/features/auth/authApi.ts
import { createApi } from "@reduxjs/toolkit/query/react";
import axios, { AxiosRequestConfig } from "axios";
import { IUser } from "../../types/user.type";
import { baseUrl } from "../../constants/config";

// Base query con axios, similar al que vimos antes
const axiosBaseQuery =
  ({ baseUrl }: { baseUrl: string } = { baseUrl: "" }) =>
  async ({
    url,
    method,
    data,
  }: {
    url: string;
    method: AxiosRequestConfig["method"];
    data?: any;
  }) => {
    try {
      const result = await axios({
        url: baseUrl + url,
        method,
        data,
        withCredentials: true,
      });
      return { data: result.data };
    } catch (axiosError: any) {
      return {
        error: {
          status: axiosError.response?.status,
          data: axiosError.response?.data || axiosError.message,
        },
      };
    }
  };

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: axiosBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    login: builder.mutation<
      { user: IUser },
      { email: string; password: string }
    >({
      query: ({ email, password }) => ({
        url: "/v2/users/login/password",
        method: "post",
        data: { email, contraseña: password },
      }),
    }),
    // Puedes agregar un endpoint de refresh aquí si lo deseas, aunque el baseQuery con reautenticación lo puede manejar
  }),
});

export const { useLoginMutation } = authApi;
